<template>
  <transition name="modal">
    <div class="modal" ref="myModal" @click="hideModal">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        :class="modalSize"
        @click.stop
      >
        <component v-bind:is="modalName" :data="modalData" />
      </div>
    </div>
  </transition>
</template>

<script>
import ImagePreview from "./comps/ImagePreview.vue";
import AudioPlayer from "./comps/AudioPlayer.vue";
import VideoPlayer from "./comps/VideoPlayer.vue";
import DefaultFile from "./comps/DefaultFile.vue";
import InstagramLoginForm from "./comps/InstagramLoginForm.vue";
import { SET_MODAL_HEIGHT } from "@/core/services/store/modal.module";

export default {
  name: "Modal",
  components: {
    ImagePreview,
    AudioPlayer,
    VideoPlayer,
    DefaultFile,
    InstagramLoginForm
  },
  mounted() {
    this.$store.commit(SET_MODAL_HEIGHT, this.$refs.myModal.offsetHeight);
  },
  computed: {
    modalName() {
      return this.$store.state.modal.modalName;
    },
    modalData() {
      return this.$store.state.modal.modalData;
    },
    modalSize() {
      return {
        "modal-xl": false,
        "modal-lg": this.modalName === "ImagePreview",
        "modal-sm": false
      };
    }
  }
};
</script>

<style lang="scss">
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: block;
  transition: opacity 0.4s ease;
  overflow: auto;

  .modal-xl {
    max-width: 96%;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
